import React from "react";
import moment from "moment";
import { Tooltip } from "antd";

// translate a subscription status to its Hebrew label
export const statusLabel = (status: string) => {
    if (status == 'ACTIVE') return 'פעיל'
    if (status == 'CANCELED') return 'בוטל'
    if (status == 'BLOCKED') return 'חסום'
    return status
}

// text color for each status
const statusColor = (status: string) => {
    if (status == 'ACTIVE') return '#008000'
    if (status == 'CANCELED') return '#ff0000'
    if (status == 'BLOCKED') return '#37474f'
    return 'inherit'
}

// one line inside a subscription dropdown: name | status badge | paid date
// `extra` is optional trailing content (e.g. special-sub date range)
export default function SubscriptionOptionLabel(props) {
    const { name, subscription_status, paid_at, extra } = props
    // shorten long names: keep 30 chars, then "..."
    const short_length=30
    const shortName = name && name.length > short_length ? name.slice(0, short_length) + '...' : name
    return (
        <span title={name} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', width: '100%', direction: 'rtl' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                {/* tooltip only when the name was actually shortened */}
                <Tooltip title={shortName !== name ? name : ''}>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{shortName}</span>
                </Tooltip>
                {/* status comes before the date */}
                {subscription_status ? (
                    <span style={{
                        color: statusColor(subscription_status),
                        fontSize: '14px',
                        whiteSpace: 'nowrap'
                    }}>
                        {statusLabel(subscription_status)}
                    </span>
                ) : ''}
                {paid_at ? (
                    <span style={{ color: '#888', fontSize: '14px', opacity: 0.6, whiteSpace: 'nowrap' }}>
                        שולם ב: {moment(paid_at).format('DD/MM/YYYY')}
                    </span>
                ) : ''}
            </span>
            {extra ? extra : ''}
        </span>
    )
}
